const currencySymbols: Record<string, string> = {
  USD: '$',
  EUR: '€',
  GBP: '£',
  JPY: '¥',
  CHF: 'CHF',
  AUD: 'A$',
  CAD: 'C$',
  CNY: '¥',
  INR: '₹',
  ILS: '₪',
  RUB: '₽',
  BRL: 'R$',
  MXN: 'MXN$',
  ZAR: 'R',
  KRW: '₩',
  THB: '฿',
  SGD: 'S$',
  MYR: 'RM',
  IDR: 'Rp',
  PHP: '₱',
  VND: '₫',
  HKD: 'HK$',
  TWD: 'NT$',
  MMK: 'K',
  BTN: 'Nu',
  TRY: '₺',
  KZT: '₸',
  CLP: 'CLP$',
};

export function getCurrencySymbol(currency: string): string {
  return currencySymbols[currency] || currency;
}

/** The figure alone. Every currency we take has decimals, so always two. */
export function formatAmount(value: number): string {
  return value.toLocaleString('en-US', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
}

/**
 * An amount with its currency in front, two decimals.
 *
 * A currency with no symbol falls back to its code, and «USDT2,032.60»
 * does not read — so a letter mark gets a space and a real symbol stays
 * tight, as the designs draw it. An empty mark means the balance has
 * not landed; the figure goes out bare rather than with a stray space.
 */
export function formatMoney(mark: string, value: number): string {
  const gap = /[A-Za-z]$/.test(mark) ? ' ' : '';
  return mark ? `${mark}${gap}${formatAmount(value)}` : formatAmount(value);
}
